const StickyObserverHook = {
  mounted() {
    const topMargin = parseInt(getComputedStyle(this.el).top) * -1 - 1 + 'px';

    this.observer = new IntersectionObserver(
      ([e]) => {
        if (e.intersectionRatio < 1) {
          e.target.dataset.jsSticky = 'true';
        } else {
          delete e.target.dataset.jsSticky;
        }
      },
      { threshold: [1], rootMargin: `${topMargin} 0px 0px 0px` }
    );
    this.observer.observe(this.el);
  },

  beforeDestroy() {
    if (this.observer) {
      this.observer.unobserve(this.el);
    }
  },
};

export default StickyObserverHook;
